import { Currency } from "@redotech/money/currencies";
import { ReturnSummaryTotalsSchema } from "@redotech/redo-return-core-common/returns/return-totals/types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/** One row in the confirmation item lists; prices arrive display-ready. */
export const PosConfirmationItemSchema = z.object({
  id: z.string(),
  pendingReturnItemId: z.string(),
  imageSrc: z.string(),
  title: z.string(),
  subtitle: z.string().nullable(),
  quantity: z.number(),
  formattedPrice: z.string(),
  price: z.string(),
  itemValue: z.string(),
  currency: createEnum(Currency),
  presentmentCurrency: z.string(),
  exchangeRate: z.number(),
});

/**
 * Display-ready confirmation screen state, computed server-side (replaces
 * the client-side useReturnConfirmation fork in pos-ui-v2).
 */
export const PosConfirmationViewSchema = z.object({
  header: z.object({ title: z.string() }),
  currency: createEnum(Currency),
  products: z.array(PosConfirmationItemSchema),
  newItems: z.array(PosConfirmationItemSchema),
  newItemsHeader: z.string(),
  summaryFeesHeader: z.string(),
  summaryFeesOrderHeader: z.string(),
  customerInfo: z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    id: z.string(),
  }),
  shouldShowSummary: z.boolean(),
  /** Refund/store-credit copy line; null when there is nothing to show. */
  refundDetailsText: z.string().nullable(),
  // Passed through for the summary/cart/next-steps children.
  returnTotals: ReturnSummaryTotalsSchema,
});

export type PosConfirmationView = z.infer<typeof PosConfirmationViewSchema>;
export type PosConfirmationItem = z.infer<typeof PosConfirmationItemSchema>;

export const getPosConfirmationView = {
  name: "getPosConfirmationView" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({ view: PosConfirmationViewSchema }),
};
